import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { StoreDataSource } from '../types/data-source';

export const expressionBuilder =
  (config: ApiConfig) =>
  (data: { expression: string; cache_data_sources?: StoreDataSource[] }): Promise<any> => {
    return fetchWrapper(
      `${config.userapiendpoint}fin-gen/expressions_builder`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
  };

export const validateSignal =
  (config: ApiConfig) =>
  (data: {
    handle: string;
    definition: {
      editor_mode: string;
      source: string;
    };
    organization_id: number;
  }): Promise<any> =>
    fetchWrapper(
      `${config.userapiendpoint}fin-gen/signals/validate`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
